interface FilterBarProps {
  genres: string[];
  regions: string[];
  years: string[];
  genre: string;
  region: string;
  year: string;
  onGenre: (value: string) => void;
  onRegion: (value: string) => void;
  onYear: (value: string) => void;
}

function ChipGroup({
  label,
  options,
  value,
  onChange,
}: {
  label: string;
  options: string[];
  value: string;
  onChange: (value: string) => void;
}) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4">
      <span className="shrink-0 text-sm text-foreground-600 sm:w-12 sm:pt-1.5">{label}</span>
      <div className="flex flex-wrap gap-2">
        <button
          type="button"
          onClick={() => onChange("all")}
          className={`px-3 py-1.5 rounded-md text-xs md:text-sm transition-colors whitespace-nowrap cursor-pointer ${
            value === "all"
              ? "bg-primary-500 text-background-50"
              : "bg-background-200/70 text-foreground-700 hover:bg-background-300/70"
          }`}
        >
          全部
        </button>
        {options.map((option) => (
          <button
            key={option}
            type="button"
            onClick={() => onChange(option)}
            className={`px-3 py-1.5 rounded-md text-xs md:text-sm transition-colors whitespace-nowrap cursor-pointer ${
              value === option
                ? "bg-primary-500 text-background-50"
                : "bg-background-200/70 text-foreground-700 hover:bg-background-300/70"
            }`}
          >
            {option}
          </button>
        ))}
      </div>
    </div>
  );
}

export default function FilterBar({
  genres,
  regions,
  years,
  genre,
  region,
  year,
  onGenre,
  onRegion,
  onYear,
}: FilterBarProps) {
  return (
    <div className="mt-6 rounded-lg bg-background-100 border border-background-300/60 p-4 md:p-5 space-y-4">
      <ChipGroup label="类型" options={genres} value={genre} onChange={onGenre} />
      <div className="h-px bg-background-300/60"></div>
      <ChipGroup label="地区" options={regions} value={region} onChange={onRegion} />
      <div className="h-px bg-background-300/60"></div>
      <ChipGroup label="年份" options={years} value={year} onChange={onYear} />
    </div>
  );
}